import { getErrorMessage } from "@lib/errors";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useRouter } from "@tanstack/react-router";
import { ErrorFallback } from "./ErrorFallback";

export function RouteErrorFallback({ error, reset }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <ErrorFallback
      message={getErrorMessage(error)}
      actions={[
        {
          label: "Try again",
          onClick: () => router.invalidate(),
        },
        {
          label: "Go home",
          onClick: () => {
            reset();
            router.navigate({ to: "/" });
          },
        },
        {
          label: "Reload page",
          onClick: () => window.location.reload(),
        },
      ]}
    />
  );
}
